import { render, staticRenderFns } from "./CateringSales.vue?vue&type=template&id=9c91d71c&scoped=true"
import script from "./CateringSales.vue?vue&type=script&lang=js"
export * from "./CateringSales.vue?vue&type=script&lang=js"
import style0 from "./CateringSales.vue?vue&type=style&index=0&id=9c91d71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c91d71c",
  null
  
)

export default component.exports